import { openBlock as t, createElementBlock as n, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 37"
};
function r(d, l) {
  return t(), n("svg", o, [...l[0] || (l[0] = [
    e("path", {
      fill: "#e82c30",
      d: "M0 7h7v19H0z"
    }, null, -1),
    e("path", {
      stroke: "#e82c30",
      d: "M3.5 0v37"
    }, null, -1),
    e("path", {
      fill: "#0f54ad",
      d: "M12 15.5h7v7h-7z"
    }, null, -1),
    e("path", {
      stroke: "#0f54ad",
      d: "M15.5 5.5v26"
    }, null, -1)
  ])]);
}
const c = { render: r };
export {
  c as default,
  r as render
};
